import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import Login from 'containers/login/Login';

class PrivateRoute extends React.PureComponent {
	render() {
		const { loggedIn, ...rest } = this.props;

		if (!loggedIn) {
			return <Login />
		}

		return (
			<Route {...rest} />
		)
	}

}

const mapStateToProps = state => {
	return {
		loggedIn: !state.login.requiresLogin,
	};
};

export default connect(mapStateToProps)(PrivateRoute);


// WEBPACK FOOTER //
// ./src/config/PrivateRoute.js